export * from "./TitledText";
